import type { SurveyQuestion } from '../../../types/index';
import type { ApiQuestion } from '../../../internalTypes';
import { resolveQuestionShell } from './shared/resolveQuestionShell';
import { mapSkipLogics } from './shared/mapSkipLogics';
import { mapDisplayLogic } from './shared/mapDisplayLogic';
import { mapQuestionDisplayVariants } from './shared/mapQuestionDisplayVariants';
import { attachQuestionLogics } from './shared/attachQuestionLogics';
import type { QuestionBeforeLogics } from './shared/questionMapperTypes';
import { mapMcqQuestion } from './mcq/mapMcqQuestion';
import { logUnknownAnswerType } from '../../../logger/mapperLogger';
import { resolveQuestionMapper } from './registry';

export function mapQuestion(
  raw: ApiQuestion,
  language?: string,
  placeholders?: Record<string, string>
): SurveyQuestion {
  const configs = raw.questionConfigs ?? [];
  const shell = resolveQuestionShell(raw, configs, language, placeholders);
  const skipLogics = mapSkipLogics(raw.controlConfig?.skipLogics);
  const displayLogic = mapDisplayLogic(raw.controlConfig?.displayLogic);
  const displayVariants = mapQuestionDisplayVariants(raw, language, placeholders);

  const withLogics = (question: QuestionBeforeLogics): SurveyQuestion =>
    attachQuestionLogics(question, skipLogics, displayLogic, displayVariants);

  const mapper = resolveQuestionMapper(raw.answerType);
  if (mapper) {
    return withLogics(mapper({ raw, shell, configs, language }));
  }

  logUnknownAnswerType(raw.answerType, raw.id ?? shell.id);
  return withLogics(mapMcqQuestion(raw, shell, language));
}
